(function () {
  if (window._cardGalleryInit) return;
  window._cardGalleryInit = true;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.card-gallery__btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const gallery = btn.closest('.card-gallery');
    const slides = Array.from(gallery.querySelectorAll('.card-gallery__slide'));
    const currentIndex = slides.findIndex(function (s) {
      return s.classList.contains('is-active');
    });

    slides[currentIndex].classList.remove('is-active');

    const nextIndex = btn.classList.contains('card-gallery__btn--next')
      ? (currentIndex + 1) % slides.length
      : (currentIndex - 1 + slides.length) % slides.length;

    slides[nextIndex].classList.add('is-active');
  });

})();
